var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"w-full slider",attrs:{"type":"range","max":_vm.max,"min":_vm.min},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }